import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Layout } from '../../layouts/Layout';
import { TableData } from '../../componen/table/TableData';

export const TableDataPages = () => {
  const navigate = useNavigate();
  const { user, isError } = useSelector((state) => state.auth);

  useEffect(() => {
    if (isError) navigate('/', { replace: true });
  }, [isError, navigate]);

  return (
    <Layout>
       <TableData userUuid={user?.uuid} userRole={user?.role}/>
     </Layout>
  )
}
